export default {
  disclaimerTextColor: Styles.color.black,
  rewardDescriptionColor: Styles.color.black,
  rewardImageWidthDesktop: '70%',
};
